//MUI
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

interface Props {
  level: number;
}

const PasswordStrengthMeter = ({ level }: Props) => {
  return (
    <Stack sx={{ width: '100%', height: '5px' }} direction="row" spacing={1}>
      {Array(4)
        .fill(null)
        .map((_: number, index: number) => (
          <Box
            key={index}
            sx={{
              width: '25%',
              borderRadius: '10px',
              bgcolor: index <= level - 1 ? 'success.main' : 'divider',
            }}
          ></Box>
        ))}
    </Stack>
  );
};

export default PasswordStrengthMeter;
